import React from "react";
import Header from "../homepage/header"; // Import the Header component
import "./About.css"; // Import the CSS for styling
import { FaNetworkWired, FaLock, FaSearch, FaMobileAlt, FaBrain, FaShieldAlt } from "react-icons/fa";

const About = () => {
  return (
    <div>
      <Header /> {/* Include the Header component */}
      <div className="about-container">
        <h1 className="about-title">About Us</h1>

        {/* Mission Section */}
        <section className="about-section mission-section">
          <h2>Our Mission</h2>
          <p>
            Our mission is to create a secure digital environment by conducting groundbreaking research, fostering talent, and developing practical solutions to combat emerging cyber security threats.
          </p>
        </section>

        {/* Objectives Section */}
        <section className="about-section objectives-section">
          <h2>Key Objectives</h2>
          <div className="card-container">
            <div className="card">
              <b>Research Excellence:</b>
              <p>Drive innovation in cyber security domains, including network security, cryptography, IoT security, and AI-driven threat detection.</p>
            </div>
            <div className="card">
              <b>Capacity Building:</b>
              <p>Nurture skilled professionals through specialized training programs and hands-on projects.</p>
            </div>
            <div className="card">
              <b>Collaboration:</b>
              <p>Work with government organizations, industry leaders, and academic institutions to address real-world security challenges.</p>
            </div>
            <div className="card">
              <b>Community Engagement:</b>
              <p>Promote awareness of cyber security best practices among individuals, organizations, and communities.</p>
            </div>
          </div>
        </section>

        {/* Expertise Section */}
        <section className="about-section expertise-section">
          <h2>Our Expertise</h2>
          <div className="card-container">
            <div className="card">
              <FaNetworkWired className="icon" />
              <b>Network Security:</b>
              <p>Designing secure and resilient communication systems.</p>
            </div>
            <div className="card">
              <FaLock className="icon" />
              <b>IoT Security:</b>
              <p>Protecting connected devices from unauthorized access and vulnerabilities.</p>
            </div>
            <div className="card">
              <FaSearch className="icon" />
              <b>Digital Forensics:</b>
              <p>Investigating and analyzing cyber incidents.</p>
            </div>
            <div className="card">
              <FaMobileAlt className="icon" />
              <b>5G and Blockchain:</b>
              <p>Exploring secure applications of next-generation technologies.</p>
            </div>
            <div className="card">
              <FaBrain className="icon" />
              <b>AI and ML in Security:</b>
              <p>Using artificial intelligence to predict and mitigate potential threats.</p>
            </div>
            <div className="card">
              <FaShieldAlt className="icon" />
              <b>Critical Infrastructure Security:</b>
              <p>Securing essential systems like power grids, transportation, and healthcare.</p>
            </div>
          </div>
        </section>

        {/* Facilities Section */}
        <section className="about-section facilities-section">
          <h2>Facilities</h2>
          <p>
            Our facilities are designed to support cutting-edge cyber security research and innovation. We house a state-of-the-art 5G Use Case Lab for experimenting with emerging technologies and exploring secure applications. Our dedicated Cyber Security Research Lab focuses on addressing modern cyber threats through advanced tools and methodologies. Additionally, we provide IoT-based testbeds and simulators for hands-on experimentation and validation of secure IoT solutions. Complementing these resources are our advanced computing systems, enabling AI-driven research and development to tackle complex cyber security challenges effectively.
          </p>
        </section>
      </div>
    </div>
  );
};

export default About;
